export default __webpack_public_path__ + "static/media/img5.182770d1.png";